<template>
  <div>
    <e-filters
      :searching="fetching"
      @search="filterData"
      @reset="resetFiltersLocal"
    >
      <b-row>
        <b-col md="6">
          <FormulateInput
            id="ncm"
            v-model="filters.ncm"
            type="select-searchable"
            :label="$t('NCM')"
            :placeholder="$t('Digite para pesquisar')"
            :options="getComboNcms"
            autofocus
            @fetchSearch="ncmSearch"
          />
        </b-col>
        <b-col cols="3">
          <FormulateInput
            id="active"
            v-model="filters.active"
            type="vue-select"
            :placeholder="$t('Todos')"
            :label="$t('Status')"
            :options="activeInactiveTypes()"
          />
        </b-col>

        <!-- <b-col cols="3">
          <FormulateInput
            id="province"
            v-model="filters.stateIdIbge"
            type="vue-select"
            :label="$t('Estado Destino')"
            :placeholder="$t('Todos')"
            :options="getComboStatesIdValue"
            @input="onStateFilterChange"
          />
        </b-col> -->
        <!-- <b-col cols="3">
          <e-city-search
            id="cityIdIbge"
            ref="cityIdIbgeRef"
            v-model="filters.cityIdIbge"
            name="cityIdIbge"
            :state-id-ibge="filters.stateIdIbge"
            :disabled="!filters.stateIdIbge"
            :label="$t('Município Destino')"
            :placeholder="$t('Todos')"
          />
        </b-col> -->

        <!-- <b-col cols="3">
          <FormulateInput
            id="taxEnabledSelectiveTax"
            v-model="filters.taxEnabledSelectiveTax"
            type="vue-select"
            :label="$t('Tributo Seletivo')"
            :placeholder="$t('Todos')"
            :options="activeInactiveTypes()"
          />
        </b-col> -->
      </b-row>

      <template #after_buttons>
        <e-button
          id="download"
          class="ml-1 btn-sm-block"
          variant="primary"
          icon="download"
          :busy="fetching"
          :text="$t('Exportar')"
          @click="onDownloadReport"
        />
        <!-- Button to download report (hidden by default) -->
        <a
          ref="downloadLink"
          style="display: none"
        />
      </template>
    </e-filters>

    <b-card-actions
      ref="table-card"
      action-refresh
      :show-loading="fetching"
      @refresh="getData"
    >
      <div slot="title">
        <e-page-size-selector
          :per-page="paging.pageSize"
          @change="pageSizeChange"
        />
      </div>
      <b-table
        ref="fiscalTaxParameters-table"
        show-empty
        responsive
        striped
        class="bordered"
        :empty-text="getEmptyTableMessage($tc('FISCAL_TAX_PARAMETER.NAME'), 'male')"
        :fields="fields"
        :items="fiscalTaxParameters"
        no-local-sorting
        :sort-by.sync="sorting.sortBy"
        :sort-desc.sync="sorting.sortDesc"
        @sort-changed="getData"
      >
        <template #cell(action)="row">
          <e-grid-actions
            :show-update="$can('Update', 'Cfop')"
            :show-delete="false"
            @update="updateFiscalTaxParameter(row)"
          />
        </template>
      </b-table>
      <b-row>
        <b-col cols="6">
          <e-pagination-summary
            :current-page="paging.currentPage"
            :per-page="paging.pageSize"
            :total="paging.rowCount"
            :total-on-page="paging.rowsInCurrentPage"
          />
        </b-col>
        <b-col cols="6">
          <b-pagination
            v-model="paging.currentPage"
            align="right"
            :total-rows="paging.rowCount"
            :per-page="paging.pageSize"
            aria-controls="fiscalTaxParameters-table"
            @change="pageChange"
          />
        </b-col>
      </b-row>
    </b-card-actions>

    <FAB
      :main-tooltip="$t('Adicionar Parâmetro Fiscal')"
      @click="create"
    />
  </div>
</template>

<script>
import { BTable, BPagination, BRow, BCol } from 'bootstrap-vue'
import { FAB, EPageSizeSelector, EPaginationSummary } from '@/views/components'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Ripple from 'vue-ripple-directive'
import { stringUtils, downloader, statusTypes, province } from '@/mixins'
import { mapGetters, mapActions, mapState } from 'vuex'
import EFilters from '@/views/components/EFilters.vue'
import EButton from '@/views/components/EButton.vue'
import EGridActions from '@/views/components/EGridActions.vue'
import moment from 'moment'
// import ECitySearch from '@/views/components/inputs/ECitySearch.vue'

export default {
  components: {
    BTable,
    BPagination,
    BRow,
    BCol,
    BCardActions,
    EPageSizeSelector,
    EPaginationSummary,
    FAB,
    EFilters,
    EButton,
    EGridActions,
    // ECitySearch,
  },
  directives: { Ripple },
  mixins: [downloader, stringUtils, statusTypes, province],
  data() {
    return {
      loaded: false,
      fetching: false,
    }
  },

  computed: {
    ...mapGetters('app', ['stateWithStore']),
    ...mapGetters('common/ncms', ['getComboNcms']),
    ...mapGetters('common/states', ['getComboStatesIdValue']),
    ...mapState('pages/invoice/fiscalTaxParameters', [
      'fiscalTaxParameters',
      'reportData',
      'paging',
      'sorting',
      'filters',
    ]),

    fields() {
      return [
        {
          label: this.$t('Ações'),
          key: 'action',
          class: 'text-center',
          thStyle: { width: '200px' },
        },
        {
          label: this.$t('Ncm'),
          key: 'ncm',
          class: 'text-center',
          sortable: true,
        },
        {
          label: this.$t('ST CBS/IBS'),
          key: 'stCbsIbsName',
          class: 'text-center',
          thStyle: { minWidth: '200px' },
        },
        {
          label: this.$t('Class. CBS/IBS'),
          key: 'fiscalClassificationCbsIbsName',
          class: 'text-center',
          thStyle: { minWidth: '500px' },
        },
        {
          label: this.$t('CBS %'),
          key: 'cbsPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('CBS Redução %'),
          key: 'cbsReductionPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('CBS Diferimento %'),
          key: 'cbsDeferralPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('IBS UF %'),
          key: 'ibsStatePercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('IBS UF Redução %'),
          key: 'ibsStateReductionPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('IBS UF Diferimento %'),
          key: 'ibsStateDeferralPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('IBS Mun. %'),
          key: 'ibsMunicipalPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('IBS Mun. Redução %'),
          key: 'ibsMunicipalReductionPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('IBS Mun. Diferimento %'),
          key: 'ibsMunicipalDeferralPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('ST Seletivo'),
          key: 'stSelectiveTaxName',
          class: 'text-center',
          thStyle: { minWidth: '200px' },
        },
        {
          label: this.$t('Class. Seletivo'),
          key: 'fiscalClassificationSelectiveTaxName',
          class: 'text-center',
          thStyle: { minWidth: '500px' },
        },
        {
          label: this.$t('Tipo Seletivo'),
          key: 'selectiveTaxType',
          class: 'text-center',
          formatter: value => (value ? this.$t(value) : '-'),
        },
        {
          label: this.$t('% Seletivo'),
          key: 'selectiveTaxPercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('Valor/Unid.'),
          key: 'selectiveTaxValuePerUnit',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('Ativo'),
          key: 'active',
          class: 'text-center',
          formatter: value => (value ? this.$t('Sim') : this.$t('Não')),
        },
      ]
    },
  },

  mounted() {
    this.fetchStates()

    if (!this.fiscalTaxParameters.length) {
      this.getData()
    }
    setTimeout(() => {
      this.loaded = true
    }, 500)
  },

  methods: {
    ...mapActions('common/states', ['fetchStates']),
    ...mapActions('common/ncms', ['fetchNcms']),
    ...mapActions('pages/invoice/fiscalTaxParameters', [
      'fetchFiscalTaxParameters',
      'generateReport',
      'setPageSize',
      'setCurrentPage',
      'resetFilters',
      'fetchCitiesByState',
    ]),

    async ncmSearch(loading, search) {
      try {
        loading(true)
        await this.fetchNcms({ itemSearch: search })
      } catch (e) {
        this.showError({
          message: this.$t('Não foi possível fazer a pesquisa'),
        })
      } finally {
        loading(false)
      }
    },
    async getData() {
      this.$nextTick(async () => {
        try {
          this.fetching = true
          await this.fetchFiscalTaxParameters()
        } catch (error) {
          this.showGenericError({ error })
        } finally {
          this.fetching = false
        }
      })
    },
    onStateFilterChange() {
      this.filters.cityIdIbge = null
      if (this.filters.stateIdIbge && this.$refs.cityIdIbgeRef?.reset) {
        this.$refs.cityIdIbgeRef.reset()
      }
    },
    pageSizeChange(pageSize) {
      this.setPageSize(pageSize)
      this.getData()
    },
    pageChange(currentPage) {
      this.setCurrentPage(currentPage)
      this.getData()
    },

    resetFiltersLocal() {
      this.resetFilters()
      this.getData()
    },
    filterData() {
      this.setCurrentPage(1)
      this.refreshData()
    },
    refreshData() {
      this.getData()
    },

    create() {
      this.$router.push({
        name: 'fiscal-tax-parameter-add',
      })
    },

    updateFiscalTaxParameter(fiscalTaxParameter) {
      this.$router.push({
        name: 'fiscal-tax-parameter-maintain',
        params: {
          ncm: fiscalTaxParameter.item.ncm,
        },
      })
    },

    async onDownloadReport() {
      try {
        this.fetching = true
        const reportData = await this.generateReport(this.$route.params.ncm)
        const nameFile = `Parametros_Fiscais-${moment().format()}.xlsx`
        if (reportData) {
          this.forceFileDownloadXlsx(reportData, nameFile)
        } else {
          this.showError({ message: this.$t('Não foi possível recuperar os dados do relatório') })
        }
      } catch (error) {
        this.showError({ error })
      } finally {
        this.fetching = false
      }
    },
  },
}
</script>
